<template>
	<div element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" v-loading="loading">
		<div style=" font-size: 18px !important;font-weight: bold;">
			<img src="../../assets/img/gk.png" width="22px" style="margin-right: 5px;" />观课记录
		</div>
		<el-row :gutter="20" v-for="(list,index) in datalist" :key="index" class="inkuif">
			<el-col :span="3">
				<!-- <img :src="img+list.courseImg" width="100%" /> -->
				<el-image  :src="img+list.courseImg" >
					<div slot="error" class="image-slot">
						<img src="../../assets/img/mo.png" width="100%" />
					</div>
				</el-image>
			</el-col>
			<el-col :span="15" class="huiquis">
				<div style="color:#333333;font-weight: bold;">{{list.courseName}}</div>
				<div>学校：{{list.schoolName}}</div>
				<div>主讲：{{list.courseSpeaker}}</div>
				<div>时间：{{list.createTime}}</div>
			</el-col>
			<el-col :span="6" class="rijhuf">
				<div>
					<img src="../../assets/img/jl.png" width="10px" style="margin-right: 5px;" />
					共{{list.lessonCnt}}课时
				</div>
				<div class="heihuif">
					<span class="keshji huijoga" @click="guanke(list.courseId)">填写观课笔记</span>
				</div>
			</el-col>
		</el-row>
		<el-pagination
			class="yuanhuif"
			:page-size="10"
			:current-page.sync="curPage"
			@prev-click="gai"
			@next-click="gai"
			@current-change="gai"
			:hide-on-single-page="true"
			background
			layout="prev, pager, next"
			style="margin-top: 15px;"
			:total="totalCount"
		></el-pagination>
		<div
			v-if="datalist.length==0"
			style=" text-align: center;color: #666;line-height: 60px;padding-top: 40px;"
		>
			<img src="../../assets/img/wu.png" width="250px" />
			<div>您还没有观课记录</div>
		</div>
	</div>
</template>

<script>
import { notelist } from '@/api/home'
export default {
	data() {
		return {
			loading: false,
			curPage: 1,
			userId: localStorage.getItem('userId'),
			roleType: localStorage.getItem('roleType'),
			datalist: [],
			img: 'http://file.51xiaoping.com/',
			totalCount: 0,
		}
	},
	watch: {},
	methods: {
		notelist() {
			let that = this
			that.loading = true
			let params = {
				curPage: that.curPage,
				pageSize: 10,
				userId: that.userId,
				roleType: that.roleType,
			}
			notelist(params)
				.then((res) => {
					that.loading = false
					that.datalist = res.data.data.dataList
					that.totalCount = res.data.data.totalCount
				})
				.catch(() => {
					that.loading = false
				})
		},
		gai(s) {
			this.curPage = s
			this.notelist()
		},
		guanke(s) {
			this.$router.push({
				path: '/period',
				query: { id: s },
			})
		},
	},
	components: {},
	beforeMount: function () {},
	mounted() {
		this.notelist()
	},
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/index/record.vue